module.exports = __webpack_public_path__ + "img/T933.9c404f3d.jpg";